
import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[clickOutside]',
   standalone: true
})

///Directive permettant de gerer le cas "je click en dehors de la div (page complete)" qui utilise 
export class ClickOutsideDirective {

  /*EXEMPLE
  *<div
 *  clickOutside
 * (clickOutside)="onDivClickOutside()"
 * >*/

  @Output() clickOutside = new EventEmitter<void>();

  constructor(private el: ElementRef) {}

  @HostListener('document:click', ['$event.target'])
  onClick(target: HTMLElement) {
    const clickedInside = this.el.nativeElement.contains(target);

    if (!clickedInside) {
      this.clickOutside.emit();
    }
  }
}
